import React from 'react';
import OnboardingApp from './components/OnboardingApp';
import './index.css'; // or './styles/globals.css' depending on your file location

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <OnboardingApp />
    </div>
  );
}

export default App;